import React, { useEffect } from "react";
import { useAppSelector } from "../../shared/hooks/redux";
import { Col, Row } from "antd";
import OtpConfirmation from "./partials/otp-confirmation";
// import Mobile_logo_ar from '../../assets/imgs/thrivve-logo-ar.svg';
import './phone-confirmation.style.css';
import { goToLink } from "../../shared/utils/general.utils";
import { useNavigate } from "react-router-dom";
import ROUTES_ENUM from "../../shared/routes-enum";
import { useTranslation } from "react-i18next";
// import { resetPhoneConfirmationState } from "./phone-confirmation.slice";
import ResultStep from "./partials/result-step";
import { getToken } from "../../shared/services/auth-service";

function PhoneConfirmation() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { step } = useAppSelector(({ PhoneConfirmation }) => PhoneConfirmation);

    useEffect(() => {
        if (!getToken() && step === "otpConfirmation") {
            goToLink(navigate, { path: ROUTES_ENUM.LEAD_REGISTER.BASE });
        }
    }, [navigate, t, step]);
    return (
        <Row align={"middle"} justify="center" className={`phone-confirm ${step}`} style={{ minHeight: "97vh" }}>
            <Col span={24}>
                {
                    step === "result"
                        ? <ResultStep />
                        : <OtpConfirmation />
                }
            </Col>
        </Row>
    )
}
export default PhoneConfirmation;